<template>
    <div style="height: 100%;" class="myinte">
  <el-form :inline="true" :model="param" class="demo-form-inline" style="padding-left: 3px;">
    <el-form-item>
        <el-cascader size="mini" v-model="param.khs" ref="khs" style="width: 100px;"
        :options="inteboStoreSturct" class="cascader" :props="props" clearable @change="khsChange" ></el-cascader>
    </el-form-item>
    <el-form-item >
      <el-select v-model="param.status" style="width: 100px;" size="mini" placeholder="活动区域" @change="statusChange">
        <el-option label="全部" :value="0"></el-option>
        <el-option label="未审核" :value="1"></el-option>
        <el-option label="已经审核" :value="99"></el-option>
        <el-option label="已驳回" :value="-1"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-select v-model="param.isback" style="width: 100px;" size="mini" placeholder="活动区域" @change="isbackChange">
        <el-option label="全部" :value="0"></el-option>
        <el-option label="未归还" :value="1"></el-option>
        <el-option label="已归还" :value="2"></el-option>
      </el-select>
    <el-button type="primary" size="mini" @click="openApply">申请</el-button>
    </el-form-item>
  </el-form>
  
  <el-table :data="inteboMachines" height="calc(100%)" border style="width: 100%" v-loadmore="getInteboMachineByParam">
    <el-table-column prop="parentname" label="品牌" fixed></el-table-column>
    <el-table-column prop="storename" label="门店"></el-table-column>
    <el-table-column prop="goodsskuname" label="仪器型号"></el-table-column>
    <el-table-column prop="number" label="数量" width="60"></el-table-column>
    <el-table-column prop="fromdate" label="借用日期" width="100"></el-table-column>
    <el-table-column prop="todate" label="归还日期" width="100"></el-table-column>
    <el-table-column fixed="right" width="50">
        <template slot-scope="scope">
            <el-button type="text" @click="updateInteboMachineIsback(scope)" v-if="scope.row.status==99 && scope.row.isback==1">归还</el-button>
            <el-tag v-if="scope.row.status==99 && scope.row.isback==2">归还</el-tag>
            <el-tag v-if="scope.row.status==1 && scope.row.isback==1">未审核</el-tag>
            <el-tag v-if="scope.row.status==-1">已驳回</el-tag>
        </template>
    </el-table-column>
  </el-table>
</div>
</template>
<script>
    export default {
      data() {
        return {
            props:{checkStrictly: true},
            inteboStoreSturct:[],
            param:{
                khs:[],
                status:0,
                isback:0,
            },
            inteboMachines:[],
            currentpage:1,
            ismore:true,
        }
    },
    created: function () {
        let userId = this.$getUrlKey("userId");
        let code = this.$getUrlKey("code");
        if (userId || code) {
            if (userId) {
                this.getCorpUserInfo(userId);
            }
        } else {
            //window.location.href="http://wechatstaff.shmiaojie.cn:8080/AMNErp/wechat/getCorpidCode?state=7";
            window.location.href = "http://wechatstaff.shmiaojie.cn:8080/AMNErp/wechatback/getThirdCorpidCode?state=12";
        }
    },
    methods: {
        getCorpUserInfo(staffid){
            this.$post("wechat/getInteboCorpUserInfo",{staffid:staffid}).then(res=>{
                if(res.sucess) {
                let data = res.object;
                if (data.staff == null || data.staff == undefined) {
                    //如果钉钉没找到就关闭页面
                    this.$message.error('没有找到您的信息');
                } else {
                    this.staff = data.staff;
                    localStorage.setItem("token", data.token);
                    localStorage.setItem("staffid", data.staff.staffid);
                    localStorage.setItem("storeid", data.staff.storeid);
                    localStorage.setItem("staffname", data.staff.staffname);
                    localStorage.setItem("posid", data.staff.posid);
                    this.getInteboStoreSturct();
                    this.getInteboMachineByParam();
                    //this.getInteboStoreSturct();
                    //this.addApply();
                    }
                }
            });
        },
        updateInteboMachineIsback(scope){
            this.$dialog.confirm({
            title: '归还',
            message: "您确定该仪器已经归还了吗？",
            }).then(() => {
                this.$post("inteboapply/updateInteboMachineIsback",{proceid:scope.row.proceid,isback:2}).then(res=>{
                    if(res.sucess){
                        this.$message({
                        message: '归还成功',
                        type: 'success',
                        duration: 1000
                        });
                        scope.row.isback=2;
                    }
                });
            });
        },
        openApply(){
            this.$router.push({path:'/inteboMachineApply'});
        },
        isbackChange(){
            this.ismore=true;
            this.currentpage=1;
            this.inteboMachines=[];
            this.getInteboMachineByParam();
        },
        statusChange(){
            this.ismore=true;
            this.currentpage=1;
            this.inteboMachines=[];
            this.getInteboMachineByParam();
        },
        khsChange(){
            this.ismore=true;
            this.currentpage=1;
            this.inteboMachines=[];
            this.getInteboMachineByParam();
        },
        getInteboStoreSturct(){
            this.$post("inteboScheduling/getInteboStoreSturct").then(res=>{
                if(res.sucess) {
                    this.inteboStoreSturct = res.object;
                }
            });
        },
        getInteboMachineByParam(){
            if(this.ismore==false){
                return;
            }
            let applyparentid=this.param.khs[0];
            let applystoreid=this.param.khs[1];
            if(!applyparentid){
                applyparentid="";
            }
            if(!applystoreid){
                applystoreid="";
            }

            this.$post("inteboapply/getInteboMachineByParam",{applyparentid:applyparentid,applystoreid:applystoreid,
                status:this.param.status,isback:this.param.isback,currentpage:this.currentpage}).then(res=>{
                    if(res.sucess){
                        //let total=res.object.total;
                        let object=res.object;
                        if(object!=null && object.length>0){
                            for(let val of object){
                                this.inteboMachines.push(val);
                            }
                            this.currentpage++;
                        }
                        else{
                            this.ismore=false;
                        }
                    }
                });
        }
    }
}
</script>
<style style lang="scss" rel="stylesheet/scss">
.myinte .el-table{
    font-size: 10px;
}
.myinte .el-form--inline .el-form-item{
    margin-right:0px;
}
</style>


// WEBPACK FOOTER //
// src/page/intebo/inteboapply/inteboMachine.vue